import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "react-dates/initialize";
import ActivityService from "../../../../../Services/Activity.service";
import FilterBox from "./Filters/FilterBox";
import ActivityItemTypeService from "../../../../../Domain/ActivityItemType/ActivityItemType.service";
import UpdateFeed from "../../../../Presentational/ItemUpdate/UpdateFeed";
const PAGE_SIZE = 100;
const activityItemTypesShown = [
    ActivityItemTypeService.MeetingId,
    ActivityItemTypeService.TaskId,
    ActivityItemTypeService.SurveyId,
    ActivityItemTypeService.PersonId,
    ActivityItemTypeService.ResourceShareId,
];
const AdvisorStudentsStaffActivityTab = (props) => {
    const [filterBoxFilters, setFilterBoxFilters] = React.useState(null);
    // The filter box which this component uses will set the filters once it mounts.  We don't want to load
    // activity feed filters until after we it's set, otherwise we'll end up loading it twice.
    // We use this state variable to keep track of whether it has been set by the filter.
    const [receivedFilterFromBox, setReceivedFilterFromBox] = React.useState(false);
    const itemSearch = React.useMemo(() => {
        if (filterBoxFilters) {
            return Object.assign(Object.assign({}, filterBoxFilters), { global: Object.assign(Object.assign({}, filterBoxFilters.global), { contextPeoplePersonIds: [props.student.personId], activityItemTypeIds: filterBoxFilters.global.activityItemTypeIds ||
                        activityItemTypesShown }) });
        }
        if (!receivedFilterFromBox) {
            return null;
        }
        return {
            global: {
                contextPeoplePersonIds: [props.student.personId],
                activityItemTypeIds: activityItemTypesShown,
            },
            latestValue: [],
        };
    }, [filterBoxFilters, props.student.personId, receivedFilterFromBox]);
    const onFilter = React.useCallback((filter) => {
        setReceivedFilterFromBox(true);
        setFilterBoxFilters(filter);
    }, []);
    const poll = React.useCallback(() => ActivityService.areThereRecentEventsForPerson(props.student.personId), [props.student.personId]);
    return (_jsx(UpdateFeed, { search: itemSearch, poll: poll, pageSize: PAGE_SIZE, filterComponent: _jsx(FilterBox, { personId: props.student.personId, onFilter: onFilter }), commentContext: {
            id: props.student.personId,
            activityItemTypeId: ActivityItemTypeService.PersonId,
        } }));
};
export default AdvisorStudentsStaffActivityTab;
